module.exports = __webpack_public_path__ + "img/451495bd1f5dcfc12204a27a783e86b2.3a59463c.png";